import { Container } from 'react-bootstrap'

function WhyJoinList () {
    return (
        <div className="whyjoinList">
            <div className="bg-light-gray whyjoinList__knowledge">
                <Container>
                    <div className="d-flex align-items-center">
                        <div className="position-relative">
                            <img src="../images/home/one.png" alt="one" className="img-fluid position-absolute"/>
                            <div className="whyjoinList__content pt-4">
                                <h6><strong>Knowledge is Power</strong></h6>
                                <p className="whyjoinList__knowledge--desc h7">We're on a mission to empower people to become more informed consumers so they make safer, healthier choices that will impact their lives, the health of their families, communities and planet.</p>
                            </div>
                        </div>
                        <img src="../images/home/knowledge02.png" alt="knowledge is power" className="whyjoinList__knowledge--img img-fluid d-md-block d-none"/>
                    </div>
                </Container>
            </div>
            <div className="whyjoinList__alternative pt-4 bg-lighter-gray">
                <Container>
                    <div className="d-flex flex-lg-row-reverse align-items-center justify-content-between">
                        <div className="position-relative ml-lg-7">
                            <img src="../images/home/two.png" alt="one" className="img-fluid position-absolute"/>
                            <div className="whyjoinList__content position-relative">
                                <h6><strong>An Alternative Approach</strong></h6>
                                <p className="h7">Disease and health are direct opposites!</p>
                                <p className="h7">Let the doctors treat disease. That's what they were trained to do. <br className="d-xl-block d-none" />This is why it's critical that you have access to information that helps you approach health from a preventative and health building mindset.</p>
                            </div>
                        </div>
                        <img src="../images/home/alternative03.png" alt="knowledge is power" className="img-fluid w-40 d-md-block d-none"/>
                    </div>
                </Container>
            </div>
            <div className="bg-light-gray whyjoinList__debunking">
                <Container>
                    <div className="d-flex align-items-center">
                        <div className="position-relative">
                            <img src="../images/home/three.png" alt="one" className="img-fluid position-absolute"/>
                            <div className="whyjoinList__content position-relative pt-5">
                                <h6><strong>Debunking Myths and Misleading Information</strong></h6>
                                <p className="h7">There is too much misleading and confusing information prevalent in the nutrition sphere today. We'll help you cut through the hype and get the truth as known by the best science available.</p>
                            </div>
                        </div>
                        <img src="../images/home/debunking.png" alt="knowledge is power" className="whyjoinList__knowledge--img img-fluid d-md-block d-none"/>
                    </div>
                </Container>
            </div>
            <div className="whyjoinList__free pt-4 bg-lighter-gray">
                <Container>
                    <div className="d-flex flex-lg-row-reverse flex-column align-items-lg-center">
                        <div className="position-relative">
                            <img src="../images/home/four.png" alt="one" className="img-fluid position-absolute"/>
                            <div className="whyjoinList__content freeContent position-relative pt-4">
                                <h6><strong>It's Free</strong></h6>
                                <p className="h7">You'd normally have to pay an expensive monthly subscription fee to get access to this kind of information.</p>
                                <p className="h7"><strong>You get a lot of valuable content at no cost!</strong></p>
                                <p className="h7">You'll always have free access because we're on this journey with you!</p>
                            </div>
                        </div>
                        <img src="../images/home/free.png" alt="It's Free" className="img-fluid w-50 position-relative whyjoinList__free--img"/>
                    </div>
                </Container>
            </div>

            <style jsx>{`
            .whyjoinList__knowledge--desc{
                    width: 64%;
            }

            .whyjoinList__content{
                padding-left:5rem;
                position:relative;
                z-index:1;
            }

            .whyjoinList__knowledge--img{
                    margin-top: -8rem;
            }

            .whyjoinList__content.freeContent{
                padding-left:5.5rem;
            }

            .whyjoinList h6{
                font-size:1.189rem;
            }

            @media(max-width:1199px){
                .whyjoinList__knowledge--img{
                    margin-top:0;
                    width:30%;
                }
            }

            @media(max-width:991px){
                .whyjoinList__free img{
                    left:-3rem;
                }
                .whyjoinList__knowledge--desc{
                    width:100%;
                }
            }

            @media(max-width:767px){
                .whyjoinList__content{
                    padding-left:0;
                    
                }
                .whyjoinList__content p{
                    width:47%;
                }
                .whyjoinList__content h6{
                    width:85%;
                }
                .whyjoinList__knowledge{
                    background: url("../images/home/knowledge-mobile01.png") right bottom no-repeat;
                    padding: 3rem 0!important;
                }
                .whyjoinList__content.freeContent p, .whyjoinList__free--img{
                    width:100%!important;
                }
                .whyjoinList__alternative{
                    background: url("../images/home/alternative-mobile01.png") right center no-repeat;
                    padding: 1rem 0;
                }
                .whyjoinList__debunking{
                    background: url("../images/home/debunking-mobile01.png") right bottom no-repeat;
                    padding: 2rem 0;
                }
                .whyjoinList__content.freeContent{
                    padding-left:0;
                }
                
            }
            @media(max-width:380px){
                .whyjoinList__knowledge{
                    padding: 2rem 0!important;
                }
            }
                
            `}</style>
        </div>
    );
}

export default WhyJoinList;